import { render } from "./customerQualityControl.vue?vue&type=template&id=509615ff&scoped=true"
import script from "./customerQualityControl.vue?vue&type=script&lang=js"
export * from "./customerQualityControl.vue?vue&type=script&lang=js"

import "./customerQualityControl.vue?vue&type=style&index=0&id=509615ff&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-509615ff"

export default script